import { useRef, useState } from "react";
import { manualInputBtn } from "../../../consts/demandplanning";
import { fmt$ } from "../../../consts/demandplanning";

const neutralBtn =
    "inline-flex items-center justify-between transition-colors rounded-md bg-white border border-gray-300 hover:bg-gray-50 text-left";

export const RevenueInputForecastDemand = ({
    value,
    onSave,
    neutralStyle = false,
    className = "",
}) => {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState("");
    const skipBlurCommitRef = useRef(false);

    const startEdit = () => {
        const n = value == null ? NaN : Number(value);
        setDraft(!Number.isFinite(n) || n === 0 ? "" : String(Math.trunc(n)));
        setEditing(true);
    };

    const performCommit = () => {
        const digits = String(draft).replace(/[^0-9]/g, "");
        if (digits === "") {
            setEditing(false);
            return;
        }
        const num = parseInt(digits, 10);
        if (!Number.isNaN(num) && num >= 0) {
            onSave(num);
        }
        setEditing(false);
    };

    const handleBlur = () => {
        if (skipBlurCommitRef.current) {
            skipBlurCommitRef.current = false;
            return;
        }
        performCommit();
    };

    const setDigitsOnly = (raw) => {
        setDraft(String(raw).replace(/[^0-9]/g, ""));
    };

    if (editing) {
        return (
            <input
                autoFocus
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="off"
                value={draft}
                onChange={(e) => setDigitsOnly(e.target.value)}
                onBlur={handleBlur}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        performCommit();
                    }
                    if (e.key === "Escape") {
                        e.preventDefault();
                        skipBlurCommitRef.current = true;
                        setEditing(false);
                    }
                }}
                className={`${neutralStyle ? "w-full max-w-none h-[44px]" : "min-w-[220px] w-auto px-5 h-[44px]"} text-center tabular-nums py-1 text-[18px] font-semibold border border-gray-300 rounded-[4px] bg-white text-gray-900 outline-none ${className}`.trim()}
            />
        );
    }

    return (
        <button
            type="button"
            onClick={startEdit}
            className={
                neutralStyle
                    ? `${neutralBtn} px-2 py-1 min-h-[44px] w-full ${className}`.trim()
                    : `${manualInputBtn} min-w-[220px] w-auto px-5 py-1 !h-auto text-center tabular-nums ${className}`.trim()
            }
            title="Click to edit"
        >
            <span className={`font-semibold text-gray-900 ${neutralStyle ? "text-lg" : "text-[22px]"}`}>{fmt$(value)}</span>
        </button>
    );
}
